(function (root, factory) {
    const api = factory();
    if (typeof module === 'object' && module.exports) module.exports = api;
    else root.SquaretalkMenu = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
    function createMenuController({document, desktopQuery = '(min-width: 1100px)'}) {
        const button = document.querySelector('[data-menu-toggle]');
        const panel = document.querySelector('[data-menu-panel]');
        if (!button || !panel) return {destroy() {}};

        const window = document.defaultView;
        const header = button.closest('[data-site-header]') || panel.closest('[data-site-header]');
        const desktop = window.matchMedia(desktopQuery);
        const groups = [...document.querySelectorAll('[data-nav-group]')].map((group) => ({
            group,
            trigger: group.querySelector('[data-nav-trigger]'),
            panel: group.querySelector('[data-nav-panel]')
        })).filter(({trigger, panel}) => trigger && panel);

        const setGroup = (entry, open, {focusTrigger = false} = {}) => {
            entry.trigger.setAttribute('aria-expanded', String(open));
            entry.panel.hidden = !open;
            entry.group.toggleAttribute('data-nav-open', open);
            if (focusTrigger) entry.trigger.focus();
        };
        const closeGroups = ({except = null, focusTrigger = false} = {}) => {
            groups.forEach((entry) => {
                if (entry !== except && entry.trigger.getAttribute('aria-expanded') === 'true') {
                    setGroup(entry, false, {focusTrigger});
                }
            });
        };
        const openMobileMenu = () => {
            button.setAttribute('aria-expanded', 'true');
            panel.hidden = false;
            document.body.classList.add('st-menu-open');
            panel.querySelector('button, a')?.focus();
        };
        const closeMobileMenu = ({restoreFocus = true} = {}) => {
            closeGroups();
            button.setAttribute('aria-expanded', 'false');
            panel.hidden = true;
            document.body.classList.remove('st-menu-open');
            if (restoreFocus) button.focus();
        };
        const onButtonClick = () => {
            if (desktop.matches) return;
            if (button.getAttribute('aria-expanded') === 'true') closeMobileMenu();
            else openMobileMenu();
        };
        const groupHandlers = groups.map((entry) => ({
            entry,
            handler: () => {
                closeGroups({except: entry});
                const open = entry.trigger.getAttribute('aria-expanded') !== 'true';
                setGroup(entry, open);
            }
        }));
        const onDocumentClick = (event) => {
            if (desktop.matches && header && !header.contains(event.target)) {
                const focusedGroup = groups.find((entry) => entry.panel.contains(document.activeElement));
                closeGroups();
                focusedGroup?.trigger.focus();
            }
        };
        const onKeydown = (event) => {
            if (event.key !== 'Escape') return;
            const activeGroup = groups.find((entry) => entry.trigger.getAttribute('aria-expanded') === 'true');
            if (activeGroup) {
                setGroup(activeGroup, false, {focusTrigger: true});
            } else if (!desktop.matches && button.getAttribute('aria-expanded') === 'true') {
                closeMobileMenu();
            }
        };
        let wasDesktop = desktop.matches;
        const syncBreakpoint = (matches) => {
            if (matches === wasDesktop) return;
            const focusInPrimaryPanel = panel.contains(document.activeElement);
            const focusedGroup = matches && groups.find((entry) => (
                entry.trigger.getAttribute('aria-expanded') === 'true' && entry.panel.contains(document.activeElement)
            ));
            closeGroups();
            button.setAttribute('aria-expanded', 'false');
            document.body.classList.remove('st-menu-open');
            panel.hidden = !matches;
            if (focusedGroup) focusedGroup.trigger.focus();
            else if (!matches && focusInPrimaryPanel) button.focus();
            wasDesktop = matches;
        };
        const onMediaChange = (event) => syncBreakpoint(event.matches);
        const onResize = () => syncBreakpoint(desktop.matches);

        header?.setAttribute('data-menu-enhanced', '');
        button.hidden = false;
        groups.forEach((entry) => setGroup(entry, false));
        button.setAttribute('aria-expanded', 'false');
        panel.hidden = !desktop.matches;

        button.addEventListener('click', onButtonClick);
        groupHandlers.forEach(({entry, handler}) => entry.trigger.addEventListener('click', handler));
        document.addEventListener('click', onDocumentClick);
        document.addEventListener('keydown', onKeydown);
        desktop.addEventListener('change', onMediaChange);
        window.addEventListener('resize', onResize);

        return {
            destroy() {
                button.removeEventListener('click', onButtonClick);
                groupHandlers.forEach(({entry, handler}) => entry.trigger.removeEventListener('click', handler));
                document.removeEventListener('click', onDocumentClick);
                document.removeEventListener('keydown', onKeydown);
                desktop.removeEventListener('change', onMediaChange);
                window.removeEventListener('resize', onResize);
                button.setAttribute('aria-expanded', 'false');
                button.hidden = true;
                panel.hidden = false;
                groups.forEach((entry) => {
                    entry.trigger.setAttribute('aria-expanded', 'true');
                    entry.panel.hidden = false;
                    entry.group.removeAttribute('data-nav-open');
                });
                document.body.classList.remove('st-menu-open');
                header?.removeAttribute('data-menu-enhanced');
            }
        };
    }
    return {createMenuController};
});
